export const MAX_DELAY_SECONDS = {
    toolCall: 10,
    postCall: 4 * 7 * 24 * 60 * 60
};
export const getMaxDelayDescription = (isToolCall) => {
    return isToolCall ? '10 seconds' : '4 weeks';
};
const UNIT_TO_SECONDS = {
    seconds: 1,
    minutes: 60,
    hours: 60 * 60,
    days: 24 * 60 * 60,
    weeks: 7 * 24 * 60 * 60
};
export const convertDelayToSeconds = (value, unit) => value * UNIT_TO_SECONDS[unit];
export const convertDelayToMilliseconds = (value, unit) => value * UNIT_TO_SECONDS[unit] * 1000;
export const parseDelayValue = (value) => {
    const numeric = typeof value === 'number' ? value : Number(value);
    if (isNaN(numeric) || numeric < 1 || !Number.isInteger(numeric)) {
        throw new Error(`Invalid resolved delay value: "${value}". Must resolve to a positive integer.`);
    }
    return numeric;
};
//# sourceMappingURL=delay-utils.js.map